import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Price } from '@bottomless/common/components';

const PricingFAQComponent = ({ pricingRule: rawPricingRule }) => {
  const pricingRule = useMemo(
    () =>
      rawPricingRule || {
        monthly_fee: 799,
        free_shipping: true,
        discount_proportion: 0.9,
        first_bag_discount: 0.8,
        free_trial_length: 30,
      },
    [rawPricingRule]
  );

  const firstBagDiscount = useMemo(() => {
    if (!pricingRule.first_bag_discount) {
      return 0;
    }

    return 100 - pricingRule.first_bag_discount * 100;
  }, [pricingRule.first_bag_discount]);

  const nextBagDiscount = useMemo(() => {
    if (!pricingRule.discount_proportion) {
      return 0;
    }

    return 100 - pricingRule.discount_proportion * 100;
  }, [pricingRule.discount_proportion]);

  return (
    <>
      Membership costs <Price value={pricingRule.monthly_fee} cents />
      /month and includes the scale{pricingRule.free_shipping ? ' and unlimited shipping' : ''}.
      {(firstBagDiscount || nextBagDiscount) && (
        <>
          {' '}
          Additionally, you&apos;ll get {firstBagDiscount ? `${firstBagDiscount}% off your first bag and a ` : ''}
          {nextBagDiscount}% discount off each subsequent order.
        </>
      )}
    </>
  );
};

PricingFAQComponent.propTypes = {
  pricingRule: PropTypes.object,
};

export const PricingFAQ = connect(({ user }) => ({
  pricingRule: user.me ? user.me.pricingRule : user.pricingRule,
}))(PricingFAQComponent);
